





















































































import { defineComponent } from "@vue/composition-api";
import { BButton } from "bootstrap-vue";
import useTour from "@/composables/useTour";
// @ts-ignore
import router from "@/router";

export default defineComponent({
    name: "Tour",
    props: {
        module: {
            type: String,
            required: true,
        },
        options: {
            type: Object,
        },
    },
    components: {
        BButton,
    },
    setup(props) {
        const { getSteps, stopTour, tourCallbacks } = useTour(props.module);

        const openHref = (link: string): void => {
            stopTour(); // Close the current module tour before we go to another module, otherwise the tour will open again when going back.
            router.push(link);
        };

        return {
            stopTour,
            openHref,
            steps: getSteps(),
            tourCallbacks,
        };
    },
});
